export const AUTH_COOKIE_NAME = 'auth';
export const AUTH_EXP_COOKIE_NAME = 'auth_exp';
